import React from "react";
import styles from "./Backdrop.module.scss";

const cssClassName = "backdrop";

const Backdrop = () => <div className={styles[cssClassName]}></div>;

export default Backdrop;
